import { PageContainer } from "src/components/organisms/contents";
import { ReactComponent as IconCoin } from "../../styles/assets/svg/icon_coin_colored.svg";
import { useNavigate } from "react-router-dom";
import { Buttons } from "src/components/atoms/Buttons";
// import shopStarbucks from "../../styles/assets/img/shop_starbucks.png";
// import shopHeadset from "../../styles/assets/img/shop_headset.png";
// import shopPerfume from "../../styles/assets/img/shop_perfume.png";
// import shopCamera from "../../styles/assets/img/shop_camera.png";
// import shopBuds3Pro from "../../styles/assets/img/shop_buds3Pro.png";
// import shopNintendo from "../../styles/assets/img/shop_nintendo.png";
import { useUserRegister } from "src/common/hooks/useUserRegister";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { ReactComponent as IconOpenWating } from "../../styles/assets/svg/icon_openWating.svg";

export const shopData = [
  // {
  //   oid: "1",
  //   title: "스타벅스",
  //   name: "아메리카노 Tall",
  //   price: 4500,
  //   imgSrc: shopStarbucks,
  //   buyDate: "2025.03.18",
  //   isUse: false,
  // },
  // {
  //   oid: "2",
  //   title: "인시스트로닉스",
  //   name: "전지전능한 헤드셋",
  //   price: 8500,
  //   imgSrc: shopHeadset,
  //   buyDate: "2025.03.20",
  //   isUse: false,
  // },
  // {
  //   oid: "3",
  //   title: "인넬",
  //   name: "매혹적인 향수",
  //   price: 8000,
  //   imgSrc: shopPerfume,
  //   buyDate: "2025.03.22",
  //   isUse: false,
  // },
  // {
  //   oid: "4",
  //   title: "인시스트로닉스",
  //   name: "감각적인 카메라",
  //   price: 8000,
  //   imgSrc: shopCamera,
  //   buyDate: "2025.03.23",
  //   isUse: false,
  // },
  // {
  //   oid: "5",
  //   title: "삼성전자",
  //   name: "갤럭시 버즈3 Pro",
  //   price: 12000,
  //   imgSrc: shopBuds3Pro,
  //   buyDate: "2025.03.12",
  //   isUse: true,
  // },
  // {
  //   oid: "6",
  //   title: "닌텐도",
  //   name: "닌텐도 스위치",
  //   price: 9500,
  //   imgSrc: shopNintendo,
  //   buyDate: "2025.03.14",
  //   isUse: true,
  // },
];
export const PointBoxPage = () => {
  const navi = useNavigate();

  const { data: userInfo } = useUserRegister();

  return (
    <PageContainer isNavBar={true} active="point">
      <>
        {/* 헤더 */}
        <SubConHeader title="포인트박스" onClickArrow={() => navi(-1)} />

        {/* 포인트 정보 */}
        <div
          style={{
            width: "100%",
            maxWidth: "45rem",
            // height: 88,
            padding: 16,
            background: "linear-gradient(338deg, #FAC780 0%, #F8932D 100%)",
            borderRadius: 24,
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: 14,
                fontWeight: 700,
                lineHeight: "20px",
                color: "#fff",
              }}
            >
              <div>{userInfo?.userName}님의 포인트</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <span>{userInfo?.point?.toLocaleString()}</span>
                <IconCoin />
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                color: "#fff",
              }}
            >
              <div>지난주 실천 포인트</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <span style={{ fontWeight: 700 }}>+400</span>
              </div>
            </div>
            <Buttons
              size="lg-br"
              layout="ghost"
              type="button"
              label="구매내역 확인하기"
              onClick={() => navi("/point/changeList")}
            />
          </div>
        </div>

        {/* 포인트 상품 목록 */}
        <div
          style={{
            width: "100%",
            height: shopData.length > 0 ? "" : "calc(100% - 192px)",
            display: "grid",
            gridTemplateColumns:
              shopData.length > 0 ? "repeat(2, 1fr)" : "repeat(1, 1fr)",
            justifyContent: "center",
            alignItems: "center",
            padding: "16px 0 90px",
            gap: 16,
          }}
        >
          {shopData.length > 0 ? (
            shopData.map((item: any) => {
              return (
                <div
                  key={item.oid}
                  style={{ cursor: "pointer" }}
                  onClick={() => navi("/point/details", { state: item })}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "156px",
                      borderRadius: 16,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={item.imgSrc}
                      alt={item.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      marginTop: 8,
                    }}
                  >
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 500,
                        lineHeight: "20px",
                        color: "#A3A3A3",
                      }}
                    >
                      {item.title}
                    </span>
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 700,
                        lineHeight: "20px",
                        color: "#404040",
                      }}
                    >
                      {item.name}
                    </span>
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "20px",
                        color: "#F57C00",
                      }}
                    >
                      {item.price.toLocaleString()}P
                    </span>
                  </div>
                </div>
              );
            })
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "32px 0 ",
                  gap: 8,
                }}
              >
                <IconOpenWating />
                <h4
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    lineHeight: "28px",
                    color: "#f57c00",
                  }}
                >
                  오픈 준비중
                </h4>
                <p
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#a3a3a3",
                    textAlign: "center",
                  }}
                >
                  지금 모은 포인트로 <br />곧 건강한 선물 받으세요!
                </p>
              </div>
            </>
          )}
        </div>
      </>
    </PageContainer>
  );
};
